// React.
import { useContext, useEffect, useState } from 'react';

// Types.
import InstanceTarget from '../../../types/instance/InstanceTarget';
import { Deadlock } from '../../../types/instance/Deadlock';

// Components.
import DeadlocksTable from '../../../component/instance/table/DeadlocksTable';

// Helper.
import { fetchResults } from '../../../helpers/utils';
import DeadlockApi from '../../../api/instance/DeadlockApi';
import FilterOption from "../../../types/instance/FilterOption";
import { showError } from '../../../utils/showAlert';

import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { buildApiQuery } from "../../../helpers/timeRangeUtils";
import TabDisabledBanner from '../../../component/instance/TabDisabledBanner';

export default function Deadlocks(props: { instance: InstanceTarget, instanceTypes: any[], filterOptions: FilterOption[], setFilterOptions: Function }) {
    const {instance, instanceTypes} = props;
    const timeRangeContext = useContext(TimeRangeContext)
    const [deadlocks, setDeadlocks] = useState<Deadlock[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        async function load() {
            try {
                const instanceType = instance.type || ''
                setLoading(true);
                const results: any[][] = await fetchResults(
                    [
                        DeadlockApi.fetch(instanceType, buildApiQuery(timeRangeContext.timeRange), instance.id)
                    ]);

                if (active) {
                    setDeadlocks(results[0]);
                    setLoading(false);
                }
            } catch (x: any) {
                console.log(x.message);
                const errorMessage = x.message || x.toString();
                setError(errorMessage);
                showError('Failed to load deadlocks', errorMessage);
                setDeadlocks([]);
                setLoading(false);
            }
        }

        let active: boolean = true;
        load();
        return () => {
            // Clean up afterwards to avoid race conditions.
            active = false;
        }
    }, [timeRangeContext.timeRange.from.valueOf(), timeRangeContext.timeRange.to.valueOf(), timeRangeContext.timeRange.interval, instance.id]);

    return (<>
        <TabDisabledBanner instance={instance} instanceTypes={instanceTypes} collectFlag={!!instance.collectdeadlocks} defaultCollectKey="defaultcollectdeadlocks" featureName="Deadlocks" />
        <div className="row row-cols-1">
            <div id="statements" className="tab-pane fade show active" role="tabpanel" aria-labelledby="statements-tab">
                <DeadlocksTable setFilterOptions={props.setFilterOptions} instanceType={instance.type} filterOptions={props.filterOptions}
                                loading={loading} error={error} deadlocks={deadlocks}/>
            </div>
        </div>
    </>)
}
